import React from "react";
import PropTypes from "prop-types";
import { Grid, Paper, Typography } from "@material-ui/core";

const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  addressCard: {
    border: "1px solid #EDF2F7",
    borderRadius: 10,
    padding: 20,
    background: "#FAFBFC",
    height: "100%",
  },
  addressTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 12,
  },
  label: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 6,
    fontWeight: 500,
  },
  value: {
    fontSize: 15,
    color: "#1F2937",
    lineHeight: "24px",
    wordBreak: "break-word",
  },
};

const AddressCard = ({ title, address }) => (
  <Paper elevation={0} style={styles.addressCard}>
    <Typography style={styles.addressTitle}>
      {title}
    </Typography>

    <Typography style={styles.label}>
      Full Address
    </Typography>

    <Typography style={styles.value}>
      {address || "NA"}
    </Typography>
  </Paper>
);

const AddressDetails = ({ addressDetails }) => {
  const getAddress = (address) => {
    if (!address) return "";

    return [
      address.houseNumber,
      address.street,
      address.locality,
      address.postOffice,
      address.villageTownCity,
      address.district,
      address.state,
      address.pincode,
    ]
      .filter(Boolean)
      .join(", ");
  };

  return (
    <Paper style={styles.card}>
      <Typography style={styles.title}>
        Address Details
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <AddressCard
            title="Permanent Address"
            address={getAddress(addressDetails?.[0])}
          />
        </Grid>

        {addressDetails?.[1] && <Grid item xs={12} md={6}>
          <AddressCard
            title="Correspondence Address"
            address={getAddress(addressDetails?.[1])}
          />
        </Grid>}
      </Grid>
    </Paper>
  );
};

AddressCard.propTypes = {
  title: PropTypes.string,
  address: PropTypes.string,
};

AddressDetails.propTypes = {
  addressDetails: PropTypes.array,
};

export default AddressDetails;